import { useParams, usePathname, useRouter, useSearchParams } from "next/navigation";
import { useCallback, useEffect, useRef } from "react";
import useTNStore from "@/stores/TNStore";
import { formatValidTN } from "@/utils/general";

export default function useTNFromRoute() {
    const { tn, setTN } = useTNStore();
    const router = useRouter();
    const pathname = usePathname();
    const pathParams = useParams();
    const searchParams = useSearchParams();
    const tnPathParam = pathParams.tn instanceof Array ? pathParams.tn[0] : pathParams.tn;
    const tnQueryParam = tnPathParam || searchParams.get("tn");
    const tnRef = useRef(tn);

    const replaceRoute = useCallback(
        (search: string, replace: string): void => {
            if (replace.length > 0) {
                router.replace(pathname.replace(search, replace));
            } else {
                const index = pathname.indexOf(`/${search}`);
                router.replace(index < 0 ? "/" : pathname.slice(0, index));
            }
        },
        [router, pathname],
    );

    useEffect(() => {
        if (tnQueryParam === null || tn === tnQueryParam) return;
        const validTN = formatValidTN(tnQueryParam);
        if (tnRef.current !== tn) {
            tnRef.current = tn;
            replaceRoute(tnQueryParam, tn);
        } else if (validTN === tnQueryParam) {
            setTN(validTN);
        } else {
            replaceRoute(tnQueryParam, validTN);
        }
    }, [tn, setTN, tnQueryParam, replaceRoute]);

    return { tn, setTN };
}
